export var BackupJobSortField;
(function (BackupJobSortField) {
    BackupJobSortField["BACKUP_JOB_SORT_CREATED_TIME"] = "createdTime";
    BackupJobSortField["BACKUP_JOB_SORT_START_TIME"] = "startTime";
    BackupJobSortField["BACKUP_JOB_SORT_END_TIME"] = "endTime";
})(BackupJobSortField || (BackupJobSortField = {}));
